import React, { ReactNode } from 'react'
import BaseLayout from './base'

const DefaultLayout = ({ children }: { children: ReactNode }) => <BaseLayout>{children}</BaseLayout>

export default DefaultLayout
